import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomNavigationTitleService {
  private customNavigationTitle: string;
  private title$ = new BehaviorSubject<string | undefined>(undefined);

  public setTitle(title: string) {
    this.customNavigationTitle = title;
    this.title$.next(title);
  }
  public getCustomTitle(): string {
    return this.customNavigationTitle;
  }

  public clearTitle() {
    this.customNavigationTitle = undefined;
    this.title$.next(undefined);
  }

  public getTitle$() {
    return this.title$.asObservable();
  }
}
